module.exports = __webpack_public_path__ + "img/coinapp-setting-step-one.1a6bee67.png";